import { getDropdownItemsFromStatusConfig } from 'shared/ui/Status'
import { organizationStatusConfig } from 'entities/Organization/ui/Status/config'

export const organizationsStatusesDropdownItems =
  getDropdownItemsFromStatusConfig(organizationStatusConfig)
